import { isRequired, isUrl } from 'validations/defaultMessages';
import * as Yup from 'yup';

const Profile = {
  generalSchema: Yup.object().shape({
    name: Yup.string().required(isRequired('nome completo / razão social')).nullable(),
    business_name: Yup.string().required(isRequired('descrição do produto')).nullable(),
    document_number: Yup.string().required(isRequired('CPF/CNPJ')).nullable(),
    website: Yup.string().url(isUrl('site')).nullable(),
    about: Yup.string().max(4000, 'Sobre deve conter no máximo 4000 caracteres').nullable(),
  }),
  contactSchema: Yup.object().shape({
    contacts_email: Yup.string().required(isRequired('email de contato')).nullable(),
    contacts_phone: Yup.string().required(isRequired('telefone de contato')).nullable(),
  }),
  addressSchema: Yup.object().shape({
    address_zip_code: Yup.string().required(isRequired('Cep')).nullable(),
    address_street: Yup.string().required(isRequired('Endereço')).nullable(),
    address_number: Yup.string().required(isRequired('número')).nullable(),
    address_neighborhood: Yup.string().required(isRequired('bairro')).nullable(),
    address_city_name: Yup.string().required(isRequired('cidade')).nullable(),
    address_state: Yup.string().required(isRequired('estado')).nullable(),
  }),
  passwordSchema: Yup.object().shape({
    current_password: Yup.string().required(isRequired('senha atual')).nullable(),
    new_password: Yup.string()
      .required(isRequired('nova senha'))
      .min(8, 'A nova senha deve conter pelo menos 8 caracteres')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
        'A nova senha deve conter pelo menos 1 número, 1 letra maiúscula e 1 caractere especial'
      ),
    repeated_new_password: Yup.string()
      .required(isRequired('senha de confirmação'))
      .oneOf([Yup.ref('new_password'), null], 'A senha não é igual ao campo Nova senha'),
  }),
};

export default Profile;
